import View from 'mixins/view';
import CoverItemView from 'ui/cover/cover-item-view';
import { repository } from 'repositories/coverRepository';
import Siema from 'siema';

const elements = {
  container: '.covers-slider',
};

export default class extends View {
    constructor(model) {
        super(model);
        this.windowWidth = $(window).width();
        this.setRootEl($(`<ul class="${ elements.container.substr(1) }"></ul>`));
    }
    buildCovers() {
        this.model.get('covers').forEach(model => {
            const coverItemView = new CoverItemView(model);
            this.addChild(coverItemView);
            this.rootEl.append(coverItemView.getRootEl());
            coverItemView.render();
        });
    }
    initSlider() {
      const itemCount = this.rootEl
        .find('.covers-sliderItem')
        .length;

      const leftArrow = $('.covers-sliderArrow__left');
      const rightArrow = $('.covers-sliderArrow__right');

      const perPage = ($(window).width() > 768) ? 4 : 2;

      rightArrow.addClass('fn-hidden');
      leftArrow.addClass('fn-hidden');

      if (itemCount > perPage) {
        rightArrow.removeClass('fn-hidden');
      }

      this.rootEl.addClass('slider');
      this.slider = new Siema({
        selector: elements.container,
        perPage,
        onChange() {
          if (this.currentSlide > 0) {
            leftArrow.removeClass('fn-hidden');
          } else {
            leftArrow.addClass('fn-hidden');
          }

          if (this.currentSlide <= (itemCount - perPage - 1)) {
            rightArrow.removeClass('fn-hidden');
          } else {
            rightArrow.addClass('fn-hidden');
          }
        }
      });

      leftArrow.click(() => {
        this.slider.prev(1);
      });

      rightArrow.click(() => {
        this.slider.next(1);
      })
    }
    buildSlider() {
      this.rootEl.empty();
      this.buildCovers();
      this.initSlider();
    }
    render() {
        const model = this.model;

        $(window).resize(() => {
          if (this.windowWidth !== $(window).width()) {
            this.windowWidth = $(window).width();
            this.buildSlider();
          }
        });

        if (!model.get('covers').length) {
          repository
            .load(model.get('day'))
            .then(data => {
              model.bulkAddCovers(data.covers);
              this.buildSlider();
              });
        } else {
          this.buildSlider();
        }
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/cover/cover-slider-view.js